import getters from './tasksGetters'
import mutations from './tasksMutations'
import state from './tasksState'
import actions from './tasksActions'

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
